import createAxios from './create.axios'

// Menggunakan environment variable dari .env
const API_BASE_URL = process.env.VUE_APP_API_HOST || 'http://localhost:8020'

export default createAxios(
  API_BASE_URL,
  {
    useAuth: true,
    globalError: true
  }
)
